<app-modal
  [title]="titulo"
  [showEditButton]="(!!establecimiento) && permissionAuth.canEdit('clientes')"
  [editable]="!editando"
  [editTooltip]="'Editar establecimiento'"
  [showCloseButton]="true"
  [scrollable]="true"
  (onEditClick)="editar()"
  (onCloseClick)="cerrar()"
>
  @if (editando) {
    <app-form [formGroup]="form">
      <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
        <div>
          <app-label for="nombre">Nombre</app-label>
          <app-input-field id="nombre" formControlName="nombre" />
        </div>
        <div>
          <app-label for="objetivo">Objetivo</app-label>
          <app-select id="objetivo" formControlName="objetivo" placeholder="Seleccione un objetivo" [options]="objetivoOptions" />
        </div>
        <div>
          <app-label for="ubi_zona_id">Zona</app-label>
          <app-select id="ubi_zona_id" formControlName="ubi_zona_id" placeholder="Seleccione una zona" [options]="zonasOptions" />
        </div>
        <div>
          <app-label for="km">Kilómetro</app-label>
          <app-input-field id="km" formControlName="km" type="number" min="0" step="0.1" />
        </div>
        <div class="md:col-span-2">
          <app-label for="direccion">Dirección</app-label>
          <app-textarea id="direccion" formControlName="direccion" [rows]="2" />
        </div>
        <div>
          <app-label for="latitud">Latitud</app-label>
          <app-input-field id="latitud" formControlName="latitud" />
        </div>
        <div>
          <app-label for="longitud">Longitud</app-label>
          <app-input-field id="longitud" formControlName="longitud" />
        </div>
        <app-location-picker-trigger
          class="md:col-span-2"
          [latitud]="form.get('latitud')?.value"
          [longitud]="form.get('longitud')?.value"
          (coordinatesChange)="onCoordinatesChange($event)"
        />
      </div>
    </app-form>

    <div class="mt-6 flex justify-end gap-3">
      <app-button size="sm" variant="outline" startIcon="close" [disabled]="guardando" (btnClick)="cancelar()">Cancelar</app-button>
      <app-button *hasPermission="'clientes:' + (establecimiento ? 'edit' : 'create')" size="sm" startIcon="save" [disabled]="!form.valid" [loading]="guardando" (btnClick)="guardar()">Guardar</app-button>
    </div>
  } @else if (establecimiento) {
    <div class="flex flex-wrap items-start justify-between gap-4">
      <dl class="grid min-w-0 flex-1 grid-cols-2 gap-x-6 gap-y-3 text-sm sm:grid-cols-3">
        <div>
          <dt class="text-xs text-gray-500 dark:text-gray-400">Objetivo</dt>
          <dd class="text-gray-800 dark:text-white/90">{{ objetivoNombre }}</dd>
        </div>
        <div>
          <dt class="text-xs text-gray-500 dark:text-gray-400">Zona</dt>
          <dd class="text-gray-800 dark:text-white/90">{{ zona }}</dd>
        </div>
        <div>
          <dt class="text-xs text-gray-500 dark:text-gray-400">Ciudad</dt>
          <dd class="text-gray-800 dark:text-white/90">{{ ciudad }}</dd>
        </div>
        <div>
          <dt class="text-xs text-gray-500 dark:text-gray-400">Departamento</dt>
          <dd class="text-gray-800 dark:text-white/90">{{ departamento }}</dd>
        </div>
        <div>
          <dt class="text-xs text-gray-500 dark:text-gray-400">Km</dt>
          <dd class="text-gray-800 dark:text-white/90">{{ establecimiento.km !== null && establecimiento.km !== undefined ? (establecimiento.km | number:'1.0-0') : '-' }}</dd>
        </div>
        <div>
          <dt class="text-xs text-gray-500 dark:text-gray-400">Dirección</dt>
          <dd class="text-gray-800 dark:text-white/90">{{ establecimiento.direccion.direccion || '-' }}</dd>
        </div>
      </dl>
      <app-location-picker-trigger
        [latitud]="establecimiento.direccion.latitud"
        [longitud]="establecimiento.direccion.longitud"
        [readOnly]="true"
      />
    </div>
  }

  @if (establecimiento) {
    <div class="mt-6 border-t border-gray-200 pt-4 dark:border-gray-800">
      <div class="mb-3 flex flex-wrap items-end justify-between gap-3">
        <h3 class="text-base font-medium text-gray-800 dark:text-white/90">Animales ({{ total }})</h3>
        <app-search-input
          placeholder="RP, nombre o HBP..."
          inputId="buscar-animal-establecimiento"
          containerClass="w-64"
          [value]="busqueda"
          (searchChange)="onBusqueda($event)"
        />
      </div>

      <app-data-table
        [columns]="columnasAnimales"
        [data]="animales"
        [loading]="cargandoAnimales"
        [clickableRows]="false"
        [compact]="true"
        [emptyTitle]="'No hay animales en este establecimiento'"
        [emptySubtitle]="''"
      >
        <ng-template appTableCell="registro_particular" let-animal>{{ animal.registro_particular || '-' }}</ng-template>
        <ng-template appTableCell="nombre" let-animal>{{ animal.nombre || '-' }}</ng-template>
        <ng-template appTableCell="hbp" let-animal>{{ animal.hbp || '-' }}</ng-template>
        <ng-template appTableCell="tipo" let-animal>
          @let badge = tipoBadge(animal.tipo);
          <app-badge [color]="badge.color">{{ badge.label }}</app-badge>
        </ng-template>
        <ng-template appTableCell="tipo_animal" let-animal>{{ animal.tipo_animal_nombre || '-' }}</ng-template>
        <ng-template appTableCell="raza" let-animal>{{ animal.raza_nombre || '-' }}</ng-template>
        <ng-template appTableCell="estado" let-animal>
          <app-badge [color]="animal.activa ? 'success' : 'error'">{{ animal.activa ? 'Activo' : 'Inactivo' }}</app-badge>
        </ng-template>
      </app-data-table>

      <app-pagination
        [currentPage]="currentPage"
        [lastPage]="lastPage"
        [perPage]="perPage"
        [total]="total"
        (pageChange)="getAnimales($event)"
        (perPageChange)="onPerPageChange($event)"
      />
    </div>
  }
</app-modal>
